import { render, staticRenderFns } from "./DropAudioFile.vue?vue&type=template&id=7115e147&scoped=true&"
import script from "./DropAudioFile.vue?vue&type=script&lang=ts&"
export * from "./DropAudioFile.vue?vue&type=script&lang=ts&"
import style0 from "./DropAudioFile.vue?vue&type=style&index=0&id=7115e147&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7115e147",
  null
  
)

export default component.exports